import React from "react";
import styled from "styled-components";
import * as R from 'ramda';
import Chart from 'react-apexcharts';
import iconZoomTool from "../../../../images/icon-zoom-tool.svg";
import iconZoomToolSelected from "../../../../images/icon-zoom-tool-selected.svg";
import iconZoomReset from "../../../../images/icon-reset.svg";
import iconMove from "../../../../images/icon-move.svg";
import iconMoveSelected from "../../../../images/icon-move-selected.svg";
import {primaryTextColour} from "../../../style/styleConsts";

const ApexChart = styled(Chart)`
    .apexcharts-legend-series {
        display: flex !important;
        align-items: center !important;
        
        .apexcharts-legend-marker {
            margin-right: 0;
        }
        .apexcharts-legend-text {
            padding-left: 8px;
        }
    }
    
    .apexcharts-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 96px;
        padding: 0;
    
        .icon-selected {
            display: none;
        }
        .apexcharts-selected {
            .icon-unselected {
                display: none;
            }
            .icon-selected {
                display: inline;
            }
        }
        
        .apexcharts-zoom-icon {
            transform: unset;
            line-height: 20px;
        }
        .apexcharts-pan-icon {
            transform: unset;
            line-height: 20px;
        }
        .apexcharts-reset-icon {
            transform: unset;
            line-height: 20px;
        }
    }
`;

const ApexTimeseries = ({series, options, height}) => {
    const chartOptions = R.mergeDeepRight(DEFAULT_OPTIONS, options);
    return <ApexChart options={chartOptions}
                      series={series}
                      type="line"
                      height={height}/>;
};

const OFFSET_TO_GET_TITLE_LEGEND_AND_TOOLBAR_LINED_UP = 29.5;
const DEFAULT_OPTIONS = {
    stroke: {
        width: 2
    },
    title: {
        align: 'left',
        style: {
            fontFamily: 'Lato',
            color: primaryTextColour
        },
        offsetY: OFFSET_TO_GET_TITLE_LEGEND_AND_TOOLBAR_LINED_UP,
    },
    chart: {
        type: 'line',
        offsetY: -OFFSET_TO_GET_TITLE_LEGEND_AND_TOOLBAR_LINED_UP,
        toolbar: {
            tools: {
                download: false,
                zoom: `<div><img class="icon-unselected" src=${iconZoomTool}><img class="icon-selected" src=${iconZoomToolSelected}></div>`,
                pan: `<div><img class="icon-unselected" src=${iconMove}><img class="icon-selected" src=${iconMoveSelected}></div>`,
                zoomin: false,
                zoomout: false,
                reset: `<img src=${iconZoomReset}>`,
            },
        },
        zoom: {
            autoScaleYaxis: true,
        }
    },
    dataLabels: {
        enabled: false
    },
    markers: {
        size: 0,
    },
    tooltip: {
        x: {
            format: 'dd MMM yyyy'
        },
    },
    xaxis: {
        type: 'datetime',
        crosshairs: {
            show: true,
            stroke: {
                color: '#b6b6b6',
                width: 1,
                dashArray: 5,
            },
        },
        tooltip: {
            offsetY: 0,
        },
        labels: {
            style: {
                colors: primaryTextColour,
                fontSize: '10px',
                fontFamily: 'Lato'
            },
            hideOverlappingLabels: false,
        },
    },
    yaxis: {
        crosshairs: {
            show: true,
            stroke: {
                color: '#b6b6b6',
                width: 1,
                dashArray: 5,
            },
        },
        tooltip: {
            enabled: true,
            offsetX: -80,
        },
        labels: {
            style: {
                colors: primaryTextColour,
                fontSize: '10px',
                fontFamily: 'Lato'
            },
        },
    },
    grid: {
        yaxis: {
            lines: {
                show: false,
            },
        }
    },
    legend: {
        position: 'top',
        horizontalAlign: 'left',
        fontSize: '12px',
        fontFamily: 'Lato',
        labels: {
            colors: primaryTextColour
        },
        markers: {
            width: 13,
            height: 13,
        },
        itemMargin: {
            horizontal: 13,
        },
        offsetX: 80,
    },
};

export default ApexTimeseries;